import(/* webpackMode: "eager", webpackExports: ["PermissionsContextProvider","EventContextProvider"] */ "/vercel/path0/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/v3/layout/EventViewLayout.tsx");
